import "core-js/modules/es.array.push.js";
export default {
  name: 'WeSpCenter',
  props: {
    users: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'checkbox'
    },
    isShowLoadmore: {
      // 是否显示加载更多
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: () => []
    },
    theadData: {
      type: Object,
      default: () => {
        return {
          name: '姓名',
          id: '工号',
          dept: '组织机构'
        };
      }
    },
    positionList: {
      type: Array,
      default: () => []
    },
    showPosition: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isCheckedAll: false,
      position: ''
    };
  },

  computed: {
    // 页面渲染源数据，数据来源基于父级users
    options() {
      const {
        users,
        selected
      } = this;
      const _result = [];
      let flag = true; // 获取右侧的已选数据

      selected.forEach(obj => {
        _result.push(obj.id);
      }); // 脱离vue中数组监听

      users.forEach(item => {
        if (_result.indexOf(item.id) > -1) {
          item._isSelected = true;
        } else {
          flag = false;
          item._isSelected = false;
        }

        item.type = 1;
      }); // eslint-disable-next-line vue/no-side-effects-in-computed-properties

      this.isCheckedAll = flag;
      return users;
    }

  },
  methods: {
    checkItem(option) {
      option._isSelected = !option._isSelected;
      this.checkOne(option);
    },

    checkOne(option) {
      if (this.type === 'checkbox') {
        this.$emit('on-check', [option]);
      } else {
        this.$emit('on-check', option);
      }
    },

    checkAll(value) {
      this.isCheckedAll = value;
      this.options.forEach(item => {
        item._isSelected = value;
      });
      this.$emit('on-check', this.options);
    },

    searchUser(ele) {
      this.$emit('on-search-user', ele);
    },

    changePosition(data) {
      this.$emit('change-position', data);
    }

  }
};